// ContactHero.js
import React from 'react';
import { Link } from 'react-router-dom';

const ContactHero = () => {
  return (
    <section className="bg-cream pt-16 pb-16 md:pt-24 md:pb-20">
      <div className="max-w-5xl mx-auto px-6 text-center">
        {/* Breadcrumb */}
        <div className="flex items-center justify-center gap-2 text-sm text-muted mb-8">
          <Link to="/" className="hover:text-primary transition-colors">
            Home
          </Link>
          <span className="text-line">|</span>
          <span className="text-ink">Contact</span>
        </div>

        <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
          Get In Touch
        </p>
        <h1 className="font-display font-light text-ink leading-[1.1] text-4xl md:text-5xl mb-5">
          Contact Us Today
        </h1>
        <p className="text-muted text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
          We are proud to support families in Queensland. Get in touch to talk about the care your family needs.
        </p>
      </div>
    </section>
  );
};

export default ContactHero;
